<template>
    <div>
        <Header/>
        <Noauth v-if="Number(userInfo.is_active_course)!==1"/>
        <Course v-if="Number(userInfo.is_active_course)===1" />
        <Footer/>
    </div>
</template>
<script>
import Course from './course'
import Noauth from './noAuth'
import { mapState } from 'vuex'
export default {
    components:{
        Course,
        Noauth
    },
    computed:mapState([
        'userInfo',
    ]),
}
</script>
